const isOneDay = (_start, _end) => {
    let start = new Date(_start);
    if (!_end) return true;

    let end = new Date(_end);
    return (
        start.getDate() === end.getDate() &&
        start.getMonth() === end.getMonth() &&
        start.getFullYear() === end.getFullYear()
    );
};

export default {
    template: [
        'VFAIRS_TEMPLATE',
        data => ({
            id: data.id,
            title: data.title,
            start: data.start_date,
            end: data.end_date,
            fee: data.fee,
            image: data.image,
            active: data.active,
            body: data.body,
            oneDayEvent: isOneDay(data.start_date, data.end_date),
        }),
    ],
    GET: {},
    '/:id': {
        template: [
            'VFAIR_TEMPLATE',
            data => ({
                id: data.id,
                title: data.title,
                start: data.start_date,
                end: data.end_date,
                fee: data.fee,
                image: data.image,
                active: data.active,
                body: data.body,
                oneDayEvent: isOneDay(data.start_date, data.end_date),
            }),
        ],
        GET: {},
    },
};
